import StudentDto from "../../dto/StudentDto";

export default class WebEvaluation1InitRequest {
  listId;
  termId;
  student;
  constructor(data) {
    this.student = new StudentDto(data);
    this.listId = data.listId;
    this.termId = data.termId;
  }
}
